<template>
  <div class="component-container">
    <div class="top-box">
      <div class="box-left">
        <div class="left-icon">
          <img class="image" src="@/assets/icon_customer_service.png" />
        </div>
        <div class="middle-info">
          <div class="info-top">
            <span class="name">雪球</span>
            <span class="phone">15162244777</span>
          </div>
          <div class="desc">专属产品顾问，一对一指导，帮您梳理交易流程。</div>
        </div>
      </div>
      <div class="box-right">
        <img class="image" src="@/assets/icon_service_qr.jpeg" />
      </div>
    </div>
    <div class="title">我能为你带来什么？</div>
    <div class="info-desc">
      不同的行业流程都对应着不同的系统解决方案。<br />
      我作为您的软件顾问，我不仅及时为答疑和培训软知识。还会根据您的公司行业为您梳理流程定制方案，为您的企业保驾护航。
    </div>
    <el-form
      ref="form"
      label-width="145px"
      label-position="right"
      size="small"
      :rules="rules"
      :model="form"
    >
      <el-form-item
        class="form-content"
        size="small"
        label="联系方式："
        prop="contact"
      >
        <el-input
          v-model="form.contact"
          clearable
          placeholder="手机号/QQ号/邮箱"
        ></el-input>
      </el-form-item>
      <el-form-item
        class="form-content"
        size="small"
        label="反馈内容："
        prop="content"
      >
        <el-input
          type="textarea"
          v-model="form.content"
          :autosize="{ minRows: 4, maxRows: 8 }"
          placeholder="请详细说明您遇到的问题，或者留下您宝贵的意见和建议！"
        ></el-input>
      </el-form-item>
      <el-form-item
        class="form-content"
        size="small"
        label="上传凭证："
        prop="imageUrls"
      >
        <div class="upimg-box">
          <div v-for="(item, index) in imageFileList" :key="index">
            <LookImage :srcPath="item" @onDeleteClick="onDeleteClick(index)" />
          </div>
          <image-cropper
            v-if="imageFileList.length < 6"
            :imgSize="2"
            imageUrl=""
            :width="60"
            :height="60"
            @crop-upload-success="cropBgSuccess"
          />
        </div>
      </el-form-item>
      <el-form-item class="form-content">
        <el-button
          class="button-sure"
          size="small"
          type="primary"
          :loading="uploading"
          @click="onSureClick"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getFeedbackAdd, getImageAdd } from "@/api/accountcenter";
import LookImage from "@/components/LookImage/index";
import ImageCropper from "@/components/ImageCropper";
export default {
  name: "CustomerService",
  components: { LookImage, ImageCropper },
  data() {
    return {
      uploading: false,
      imageFileList: [],
      form: {
        contact: "",
        content: "",
      },
      rules: {
        imageUrls: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (this.imageFileList.length === 0) {
                callback(new Error("请上传凭证"));
              } else {
                callback();
              }
            },
          },
        ],
        contact: [
          {
            required: true,
            message: "手机号/QQ号/邮箱",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "请详细说明您遇到的问题，或者留下您宝贵的意见和建议！",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    onDeleteClick(index) {
      this.imageFileList.splice(index, 1);
    },
    //上传图片成功
    cropBgSuccess(data) {
      const { file } = data;
      const formData = new FormData();
      formData.append("imageFile", file);
      getImageAdd(formData)
        .then((res) => {
          const {
            data: { filePath },
          } = res;
          this.imageFileList = [...this.imageFileList, filePath];
        })
        .catch((err) => {
          this.$message.error("上传失败");
        });
    },
    onSureClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this._getFeedbackAdd();
        } else {
          return false;
        }
      });
    },
    _getFeedbackAdd() {
      this.uploading = true;
      getFeedbackAdd({ ...this.form, imageUrls: this.imageFileList })
        .then((res) => {
          const { message } = res;
          this.$message.success(message || "操作成功");
        })
        .catch((res) => {})
        .finally(() => {
          this.uploading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.component-container {
  width: 1040px;
  height: 650px;
  background-color: #ffffff;
  .top-box {
    height: 100px;
    background: linear-gradient(315deg, #5f97fc 0%, #3839e8 100%);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 25px;
    padding-right: 25px;
    .box-left {
      display: flex;
      .left-icon {
        .image {
          width: 48px;
          height: 50px;
        }
      }
      .middle-info {
        padding-left: 19px;
        text-align: left;
        .info-top {
          font-size: 18px;
          color: #ffffff;
          opacity: 0.8;
          .phone {
            margin-left: 23px;
          }
        }
        .desc {
          opacity: 0.8;
          margin-top: 3px;
          font-size: 14px;
          color: #ffffff;
        }
      }
    }
    .box-right {
      .image {
        width: 50px;
        height: 50px;
      }
    }
  }
  .title {
    font-size: 18px;
    padding-top: 25px;
    color: #333333;
    font-weight: 700;
  }
  .info-desc {
    padding-top: 15px;
    line-height: 25px;
    padding-left: 60px;
    padding-right: 60px;
    text-align: left;
    font-size: 14px;
    color: #333333;
    padding-bottom: 25px;
  }
  .form-content {
    margin-top: 20px;
    width: 800px;
    text-align: left;
    .upimg-box {
      display: flex;
      align-items: center;
    }
    .button-sure {
      margin-top: 60px;
      width: 120px;
      margin-left: -80px;
      height: 50px;
      font-size: 18px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/accountcenter/components/customerservice.vue